<script setup lang="ts">
interface SingleItem {

  translations: DirectusTranslation<{
    title: string
    description: string
  }>
  image: DirectusFile
}
const props = defineProps<{
  data: {
    block_image_with_text_single_id: {
      block_image_with_text_single_id: SingleItem
    }[]
  }
}>()

function getTranslatedTitle(block: SingleItem) {
  return dt(block.translations)?.title
}

function getTranslatedText(block: SingleItem) {
  return dt(block.translations)?.description
}

function getImage(block: SingleItem) {
  return block.image
}

const items = computed(() => props.data.block_image_with_text_single_id.map(block => ({
  title: getTranslatedTitle(block.block_image_with_text_single_id),
  description: getTranslatedText(block.block_image_with_text_single_id),
  image: getImage(block.block_image_with_text_single_id),
})))
</script>

<template>
  <BlockBase class="bg-starline-secondary py-15rem block-light:bg-neutral-white block-light:text-neutral-black signature-page:!bg-signature-black signature-page:block-light:!bg-signature-darkGray">
    <Container class="grid grid-cols-1 w-full gap-8 lg:grid-cols-2 xl:grid-cols-3">
      <div v-for="item in items" :key="item.title" class="relative h-full min-h-2xl border border-neutral-darkGray bg-black p-8 signature-page:border-signature/15">
        <div class="jusitfy-end relative z-10 h-full w-full flex flex-col">
          <div class="relative z-20 h-full w-full">
            <NuxtImg
              loading="lazy"
              class="absolute z-10 h-full w-full object-cover"
              provider="directus"
              :src="item.image.id"
              height="650"
              width="650"
              :alt="item.image.description"
            />
            <div class="gradient relative z-50 h-full w-full flex items-end justify-center text-3xl font-title">
              <p>
                {{ item.title }}
              </p>
            </div>
          </div>
          <div class="z-30 w-full flex items-end justify-end">
            <div class="z-30 max-h-max w-full flex flex-col items-center justify-center text-center">
              <p class="w-full bg-black pt-4 text-xl">
                <span class="max-w-[50ch]">
                  {{ item.description }}
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </Container>
  </BlockBase>
</template>

<style scoped>
.gradient {
  background: linear-gradient(180deg, rgba(0, 11, 26, 0) 0%, #000711 100%);
  /* url(<path-to-image>) transparent 50% / cover no-repeat; */
}
</style>
